import { AppModalComponent } from "./appModal";

export const AppModal = AppModalComponent;
